<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="['update', 'create', 'approve'].includes(formProps.editType)"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >{{ formProps.editType === 'create' ? '新增隐患' : '编辑隐患' }}</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="隐患详情"> </el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="隐患基本信息" name="baseInfo">
            <HiddenInfo
              :FormData="formData"
              :isEditLevel="formProps.editType !== 'read'"
              ref="hiddenInfo"
            ></HiddenInfo>
          </el-collapse-item>
          <el-collapse-item title="隐患审核" name="verify">
            <el-form
              ref="form"
              label-width="150px"
              :model="formData"
              v-loading="loading"
              :disabled="!formData.isCanEdit || !['update', 'create'].includes(formProps.editType)"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="隐患整改期限"
                    prop="hiddenDangerRectificationPeriod"
                    :rules="[
                      {
                        required: true,
                        validator:
                          formData.isCanEdit && ['update', 'create'].includes(formProps.editType)
                            ? validatorDate
                            : '',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-date-picker
                      size="small"
                      v-model="formData.hiddenDangerRectificationPeriod"
                      :disabled="formProps.editType === 'read'"
                      type="date"
                      class="!w-full"
                      placeholder="请选择隐患整改期限"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="隐患整改单位"
                    prop="hiddenDangerRectificationDepartmentId"
                    :rules="[
                      {
                        required: true,
                        message: '请选择隐患整改单位',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <!-- <department-select
                      ref="department"
                      v-model="formData.hiddenDangerRectificationDepartmentId"
                      :disabled="formProps.editType === 'read' || !formData.isCanEdit"
                    ></department-select> -->
                    <el-select
                      v-model="formData.hiddenDangerRectificationDepartmentId"
                      filterable
                      clearable
                      placeholder="请选择隐患整改单位"
                      size="small"
                      class="w-full"
                      :disabled="formProps.editType === 'read' || !formData.isCanEdit"
                      @change="deptChange"
                    >
                      <el-option
                        v-for="item in deptList"
                        :key="item.DeptId"
                        :label="item.DeptName"
                        :value="item.DeptId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="隐患整改负责人"
                    prop="personChargeHiddenDangerRectificationId"
                    ref="personChargeHiddenDangerRectificationId"
                    :rules="[
                      {
                        required: true,
                        validator: validatorPerson,
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <!-- <person-select
                      v-model="formData.personChargeHiddenDangerRectificationId"
                      :departmentId="formData.hiddenDangerRectificationDepartmentId"
                      :disabled="formProps.editType === 'read' || !formData.isCanEdit"
                      @selected="personSelected"
                    ></person-select> -->
                    <el-select
                      v-model="formData.personChargeHiddenDangerRectificationId"
                      class="w-full"
                      filterable
                      placeholder="请选择隐患整改负责人"
                      :disabled="formProps.editType === 'read' || !formData.isCanEdit"
                    >
                      <el-option
                        v-for="item in userList"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="隐患验收负责人"
                    prop="personChargeHiddenDangerAcceptanceId"
                    ref="personChargeHiddenDangerAcceptanceId"
                    :rules="[
                      {
                        required: true,
                        validator: validatorPerson,
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <!-- <person-select
                      v-model="formData.personChargeHiddenDangerAcceptanceId"
                      :disabled="formProps.editType === 'read'"
                    ></person-select> -->
                    <el-select
                      :disabled="formProps.editType === 'read'"
                      v-model="formData.personChargeHiddenDangerAcceptanceId"
                      class="w-full"
                      placeholder="请选择隐患验收负责人"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in acceptUsers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="风险级别"
                    prop="riskLevel"
                    :rules="[
                      {
                        required: true,
                        message: '请选择风险级别',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="formData.riskLevel"
                      class="w-full"
                      placeholder="请选择隐患风险级别"
                      filterable
                      clearable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in riskLevelList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="管控等级" prop="hiddenDangerControlGrade">
                    <el-select
                      class="w-full"
                      placeholder="请输入管控等级"
                      v-model="formData.hiddenDangerControlGrade"
                      :disabled="formProps.editType === 'read'"
                      clearable
                    >
                      <el-option
                        v-for="item in controlHierarchyList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患归属专业" prop="hiddenDangersBelongProfession">
                    <el-select
                      v-model="formData.hiddenDangersBelongProfession"
                      class="w-full"
                      placeholder="请选择隐患归属专业"
                      filterable
                      clearable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in HiddenBelongProfessionList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="期限要求" prop="isCheckCorrect">
                    <el-select
                      v-model="formData.isCheckCorrect"
                      class="w-full"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in changeTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="所属标段" prop="section">
                    <el-select
                      v-model="formData.section"
                      class="w-full"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in sectionList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="简要原因分析" prop="briefCauseAnalysis">
                    <el-input
                      type="textarea"
                      class="!w-full"
                      :rows="4"
                      v-model="formData.briefCauseAnalysis"
                      placeholder="请输入简要原因分析"
                      maxlength="1000"
                      show-word-limit
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item
                    label="整改要求"
                    prop="hiddenDangerVerifierOpinions"
                    :rules="[
                      {
                        required: true,
                        message: '请输入整改要求',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      type="textarea"
                      class="!w-full"
                      :rows="4"
                      maxlength="500"
                      show-word-limit
                      v-model="formData.hiddenDangerVerifierOpinions"
                      placeholder="请输入整改要求"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <!-- 后续需要添加一个判断是否是第四级领导，如果是第四级领导，则不显示上报领导按钮 -->
        <el-button
          type="primary"
          size="small"
          @click="submitFormLeaderToApprove"
          :loading="loading"
          v-if="showLeaderBtn"
          >上报领导审核</el-button
        >
        <el-button type="primary" size="small" @click="submitForm('save')" :loading="loading"
          >指派整改</el-button
        >
        <el-button type="danger" size="small" @click="showDialog = true" :loading="loading"
          >非隐患驳回</el-button
        >
        <el-button @click="goBack" size="small">取消</el-button>
      </div>
    </div>
    <HiddenRejectDialog
      v-if="showDialog"
      :taskId="formData.id"
      @handleOk="handleOk"
      @cancel="showDialog = false"
    ></HiddenRejectDialog>
    <!-- <SelectLeader
      v-if="leaderDialogVisible"
      :visible.sync="leaderDialogVisible"
      @selected="saveLeaderToApprove"
    ></SelectLeader> -->
    <SelecWorkFlowtUser
      v-if="leaderDialogVisible"
      formLabel="上级领导"
      :workFlowTaskId="formData.workflowTaskId"
      :isReportLeader="true"
      :visible.sync="leaderDialogVisible"
      @selected="saveLeaderToApprove"
    ></SelecWorkFlowtUser>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import DiyService from '../services/DiyService'

// import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
// import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import HiddenInfo from './business/HiddenInfo'
import HiddenRejectDialog from './business/HiddenRejectDialog'
import SelecWorkFlowtUser from './HiddenVerify/SelecWorkFlowtUser'

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()
const areaApi = new AreaApi()

export default {
  name: 'hidden-list-detail',
  components: {
    // PersonSelect,
    HiddenInfo,
    // DepartmentSelect,
    HiddenRejectDialog,
    SelecWorkFlowtUser,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },
      showDialog: false,
      loading: false,
      areaList: [],
      hiddenCategoryList: [],
      HiddenBelongProfessionList: [],
      hiddenLevelList: [],
      controlHierarchyList: [],
      acceptUsers: [],
      sectionList: [],
      riskLevelList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      changeTypeList: [
        { label: '立即整改', value: true },
        { label: '期限整改', value: false },
      ],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo', 'verify'],
      leaderDialogVisible: false, // 上报领导弹窗
      selectedLeader: '', // 选中的领导
      showLeaderBtn: false, // 上报领导审核按钮显示与否
      workFlowDesignId: '', // 流程设计id
      workFlowNodeId: '', // 流程节点id
      deptList: [], // 隐患整改单位列表
      userList: [], // 隐患整改负责人列表
      initUserList: [], // 初始化隐患整改负责人列表
    }
  },
  computed: {},
  async created() {
    this.getData()
    this.getAreaList()
    this.getAcceptUsers()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenBelongProfession',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
        'DoublePreventionManagement.DataCategory.InfrastructureBidSection',
      ],
      [
        'hiddenLevelList',
        'HiddenBelongProfessionList',
        'hiddenCategoryList',
        'controlHierarchyList',
        'sectionList',
      ],
      this
    )
    // 领导审批时，可以直接编辑也可以上报更高级领导
    if (this.formData.currentWorkflowTaskId) {
      this.formData.isCanEdit = true
    }
    if (this.formProps.editType !== 'read') {
      this.isCurrentLevelLeader()
    }
    await this.getWorkFlowDesign('隐患治理审批主流程')
    await this.getWorkFlowNodes()
    await this.getUserList()
  },

  mounted() {},

  methods: {
    /**
     * @description 整改单位切换
     */
    deptChange(newHiddenDangerRectificationDepartmentId) {
      this.formData.personChargeHiddenDangerRectificationId = ''
      if (!newHiddenDangerRectificationDepartmentId) {
        this.userList = [...this.initUserList]
        return
      }
      this.userList = this.initUserList.filter((item) => {
        return item.DeptId === newHiddenDangerRectificationDepartmentId
      })
    },

    // 获取流程
    async getWorkFlowDesign(name) {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_FlowDesign',
        _PageSize: 15,
        _PageIndex: 1,
        _Where: [{ Name: 'FlowName', Value: name, Type: 'Like' }],
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentFlowDesign = _.find(res.Data, ['FlowName', '隐患治理审批主流程'])
        if (currentFlowDesign) {
          this.workFlowDesignId = currentFlowDesign.Id
        }
      }
    },

    // 获取流程节点
    async getWorkFlowNodes() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.workFlowDesignId },
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentNode = _.find(res.Data, ['NodeName', '隐患整改'])
        if (currentNode) {
          this.workFlowNodeId = currentNode.Id
        }
      }
    },

    // 获取用户列表
    async getUserList() {
      const [err, res] = await DiyService.getNodeConfirmUsers({
        NodeId: this.workFlowNodeId,
        ApprovalType: 'Agree',
      })
      if (!err && res.Code === 1 && res.Data && res.Data.SelectUsers) {
        if (this.FormData.hiddenDangerRectificationDepartmentId) {
          this.userList = res.Data.SelectUsers.filter((item) => {
            return item.DeptId === this.FormData.hiddenDangerRectificationDepartmentId
          })
        } else {
          this.userList = [...res.Data.SelectUsers]
        }
        this.initUserList = [...res.Data.SelectUsers]
        const deptList = []
        res.Data.SelectUsers.forEach((item) => {
          const dept = deptList.find((deptItem) => {
            return deptItem.DeptName === item.DeptName
          })
          if (!dept && item.DeptId) {
            deptList.push(item)
          }
        })
        this.deptList = [...deptList]
      }
    },

    // 判断当前是第几级领导
    async isCurrentLevelLeader() {
      const flowTaskId = this.formData.currentWorkflowTaskId
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.getHiddenDangersVerificationCurrentStop({
        workflowTaskId: flowTaskId,
      })
      // 返回值只有true和false，true表示当前流程结束，false表示当前流程未结束
      if (!err && res) {
        this.showLeaderBtn = false
        return
      }
      this.showLeaderBtn = true
    },
    personSelected(data) {
      if (data.orgUnits.length) {
        this.formData.hiddenDangerRectificationDepartmentId = data.orgUnits[0].organizationUnitId
      }
    },
    goBack() {
      if (this.formProps.editType === 'approve') {
        this.$router.go(-1)
      }
      this.$emit('cancel')
    },
    validatorDate(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入隐患整改期限!'))
      }
      if (new Date() > new Date(value)) {
        callback(new Error('隐患整改期限必须大于当前时间!'))
        return
      }
      callback()
    },
    async getAcceptUsers() {
      const [err, res] = await hiddenDangerRectificationChecklistApi.getHiddenDangerExaminer()
      if (!err) {
        this.acceptUsers = res
      }
    },
    async getData() {
      this.formData = JSON.parse(JSON.stringify(this.FormData))
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    async handleOk(reason) {
      this.showDialog = false
      this.loading = true
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersVerificationOverrule({
        body: {
          id: this.formData.id,
          currentWorkflowTaskId: this.formData.currentWorkflowTaskId,
          rejectionReasons: reason,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '驳回成功',
          type: 'success',
        })
        if (this.formProps.editType === 'approve') {
          this.$router.go(-1)
        }
        this.$emit('refreshList')
        this.$emit('cancel')
      }
      this.loading = false
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    validatorPerson(rule, value, callback) {
      if (!value || !value.length) {
        callback(new Error('该字段必须填写!'))
      }
      if (
        this.formData.personChargeHiddenDangerRectificationId ===
        this.formData.personChargeHiddenDangerAcceptanceId
      ) {
        callback(new Error('隐患整改负责人和隐患验收负责人不能是同一人!'))
        return
      }
      callback()
    },
    async submitForm(type, needLeaderToApprove) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          // 日期格式处理
          this.formData.hiddenDangerRectificationDepartment = _.find(this.deptList, (item) => {
            return item.DeptId === this.formData.hiddenDangerRectificationDepartmentId
          })?.DeptName
          this.formData.creationTime = this.formData.creationTime
            ? dayjs(this.formData.creationTime).format('YYYY-MM-DD HH:mm:ss')
            : this.formData.creationTime

          this.formData.hiddenDangerRectificationPeriod = this.formData
            .hiddenDangerRectificationPeriod
            ? dayjs(this.formData.hiddenDangerRectificationPeriod).format('YYYY-MM-DD HH:mm:ss')
            : this.formData.hiddenDangerRectificationPeriod

          this.formData.reportTime = this.formData.reportTime
            ? dayjs(this.formData.reportTime).format('YYYY-MM-DD HH:mm:ss')
            : this.formData.reportTime

          this.formData.hiddenDangerlevel = this.$refs.hiddenInfo.formData.hiddenDangerlevel
          if (needLeaderToApprove) {
            this.formData.needLeaderToApprove = true
          }
          if (this.formData.hazardVerificationStatus === 2) {
            const resData = await this.$confirm(
              '该流程数据已被驳回，请检查驳回原因，确认无误后再提交',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }
            ).catch(() => {})
            if (!resData) {
              this.loading = false
              return
            }
          }
          const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangersVerification({
            id: this.formData.id,
            body: this.formData,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '指派整改成功',
              type: 'success',
            })
            if (this.formProps.editType === 'approve') {
              this.$router.go(-1)
            }
            this.$emit('refreshList')
            this.$emit('cancel')
          }
          this.loading = false
        }
      })
    },
    // 上报领导审核
    async submitFormLeaderToApprove() {
      if (this.formData.hazardVerificationStatus === 2) {
        const resData = await this.$confirm(
          '该流程数据已被驳回，请检查驳回原因，确认无误后再提交',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).catch(() => {})
        if (!resData) {
          this.loading = false
          return
        }
      }
      this.leaderDialogVisible = true
    },
    // 保存上报领导审核的内容
    async saveLeaderToApprove(userId, reportReason) {
      this.loading = true
      // 日期格式处理
      this.formData.hiddenDangerRectificationDepartment = _.find(this.deptList, (item) => {
        return item.DeptId === this.formData.hiddenDangerRectificationDepartmentId
      })?.DeptName
      this.formData.creationTime = this.formData.creationTime
        ? dayjs(this.formData.creationTime).format('YYYY-MM-DD HH:mm:ss')
        : this.formData.creationTime

      this.formData.hiddenDangerRectificationPeriod = this.formData.hiddenDangerRectificationPeriod
        ? dayjs(this.formData.hiddenDangerRectificationPeriod).format('YYYY-MM-DD HH:mm:ss')
        : this.formData.hiddenDangerRectificationPeriod

      this.formData.reportTime = this.formData.reportTime
        ? dayjs(this.formData.reportTime).format('YYYY-MM-DD HH:mm:ss')
        : this.formData.reportTime
      this.formData.needLeaderToApprove = true
      this.formData.receiverid = userId
      this.formData.reportReason = reportReason
      this.formData.hiddenDangerlevel = this.$refs.hiddenInfo.formData.hiddenDangerlevel
      const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangersVerification({
        id: this.formData.id,
        body: {
          ...this.formData,
          personChargeHiddenDangerRectificationId: this.formData
            .personChargeHiddenDangerRectificationId
            ? this.formData.personChargeHiddenDangerRectificationId
            : this.FormData.personChargeHiddenDangerRectificationId,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '上报领导审核成功',
          type: 'success',
        })
        if (this.formProps.editType === 'approve') {
          this.$router.go(-1)
        }
        this.$emit('refreshList')
        this.$emit('cancel')
      }
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
